
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function BlogList() {
  const blogPosts = [
    {
      id: 'training-tips',
      title: 'Essential Flight Training Tips for New Pilots',
      excerpt: 'Discover proven strategies and techniques that will accelerate your flight training progress and help you become a safer, more confident pilot.',
      image: 'https://readdy.ai/api/search-image?query=flight%20instructor%20teaching%20student%20pilot%20in%20aircraft%20cockpit%2C%20professional%20aviation%20training%20tips%2C%20flight%20training%20education%20scene%2C%20modern%20flight%20instruction%20environment&width=400&height=250&seq=training-tips-blog&orientation=landscape',
      date: 'October 30, 2025',
      readTime: '5 min read',
      category: 'Training'
    },
    {
      id: 'weather',
      title: 'Understanding Texas Weather Patterns for Pilots',
      excerpt: 'Learn how to read and interpret Central Texas weather conditions to make safe flying decisions and plan successful cross-country flights.',
      image: 'https://readdy.ai/api/search-image?query=texas%20weather%20patterns%20from%20pilot%20perspective%2C%20aviation%20weather%20analysis%2C%20clear%20skies%20and%20storm%20systems%20over%20central%20texas%20landscape%2C%20meteorology%20for%20pilots&width=400&height=250&seq=weather-blog&orientation=landscape',
      date: 'October 30, 2025',
      readTime: '7 min read',
      category: 'Weather'
    },
    {
      id: 'career',
      title: 'Building a Successful Aviation Career Path',
      excerpt: 'Explore the various career opportunities in aviation and learn how to build the experience and qualifications needed for your dream flying job.',
      image: 'https://readdy.ai/api/search-image?query=professional%20pilot%20career%20progression%20from%20student%20to%20airline%20captain%2C%20aviation%20career%20development%2C%20commercial%20aviation%20industry%20opportunities&width=400&height=250&seq=career-blog&orientation=landscape',
      date: 'October 30, 2025',
      readTime: '8 min read',
      category: 'Career'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-teal-600 to-teal-700 text-white py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl font-bold mb-4" style={{ fontFamily: 'Barlow, sans-serif' }}>
              Aviation Blog
            </h1>
            <p className="text-xl max-w-3xl mx-auto">
              Expert insights, training tips, and aviation knowledge from the professionals at Stiletto Airpark. Stay informed about <strong>flight training </strong> and aviation best practices.
            </p>
          </div>
        </section>

        {/* Blog Posts Grid */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {blogPosts.map((post) => (
                <article key={post.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
                  <div className="relative">
                    <img 
                      src={post.image}
                      alt={post.title}
                      className="w-full h-48 object-cover"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="bg-teal-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                        {post.category}
                      </span>
                    </div>
                  </div>
                  
                  <div className="p-6">
                    <div className="flex items-center text-sm text-gray-500 mb-3">
                      <span>{post.date}</span>
                      <span className="mx-2">•</span>
                      <span>{post.readTime}</span>
                    </div>
                    
                    <h2 className="text-xl font-bold text-gray-900 mb-3 hover:text-teal-600 transition-colors">
                      <Link to={`/blog/${post.id}`}>
                        {post.title}
                      </Link>
                    </h2>
                    
                    <p className="text-gray-600 mb-4 leading-relaxed">
                      {post.excerpt}
                    </p>
                    
                    <Link 
                      to={`/blog/${post.id}`}
                      className="inline-flex items-center text-teal-600 hover:text-teal-700 font-medium transition-colors"
                    >
                      Read More
                      <i className="ri-arrow-right-line ml-2"></i>
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="py-16 bg-teal-600 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold mb-6" style={{ fontFamily: 'Barlow, sans-serif' }}>
              Have Questions About Flight Training?
            </h2>
            <p className="text-xl mb-8 max-w-3xl mx-auto">
              Our experienced instructors are here to help with any questions about <strong>tailwheel endorsement</strong>, sport pilot training, or private pilot certification.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:706-936-8961" 
                className="bg-white text-teal-600 px-8 py-3 rounded-md text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer inline-block"
              >
                Call Bryson: 706-936-8961
              </a>
              <a 
                href="tel:512-658-3132" 
                className="border-2 border-white text-white px-8 py-3 rounded-md text-lg font-semibold hover:bg-white hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer inline-block"
              >
                Call Scott: 512-658-3132
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
